var CONST_ACTIONCODES = require('../../../constants/actionCodes'),
	ErrorResponse = require('./errorResponse');

function ServiceError(decodedResponse) {
	this.parseError(decodedResponse);
}

ServiceError.prototype = new ErrorResponse();
ServiceError.prototype.name = "ServiceError";
ServiceError.prototype.constructor  = ServiceError;

ServiceError.prototype.parseError = function(rawJson){
  this.Validated =  false;
  this.ActionCode =  CONST_ACTIONCODES.ERROR;
  this.ErrorNumber =  rawJson.ErrorNumber;
  this.ErrorDescription =  rawJson.Message;
};


module.exports = ServiceError;



//////////////////
// WEBPACK FOOTER
// ./models/errors/midas/serviceError.js
// module id = 54
// module chunks = 0 5 20